/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Permonth1Inputs */

const zh_plan_permonth1 = /** @type {(inputs: Plan_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

const en_plan_permonth1 = /** @type {(inputs: Plan_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mo`)
};

const es_plan_permonth1 = /** @type {(inputs: Plan_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

/**
* | output |
* | --- |
* | "/mo" |
*
* @param {Plan_Permonth1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_permonth1 = /** @type {((inputs?: Plan_Permonth1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Permonth1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_permonth1(inputs)
	if (locale === "en") return en_plan_permonth1(inputs)
	return es_plan_permonth1(inputs)
});
export { plan_permonth1 as "plan_perMonth" }